import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProgressComponent} from '../progress/progress.component';
import {Observable, Subscription} from 'rxjs';
import {Item} from '../../models/item';
import {BreadCrumb} from '../../models/breadcrumb';
import {ActivatedRoute, Router} from '@angular/router';
import {tap} from 'rxjs/operators';
import {doc, docData, DocumentData, DocumentReference, Firestore} from '@angular/fire/firestore';
import {BreadcrumbsComponent} from '../breadcrumbs/breadcrumbs.component';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatGridList, MatGridTile} from '@angular/material/grid-list';
import {AsyncPipe} from '@angular/common';
import {BooleanPipe} from '../../pipes/boolean.pipe';
import {DateFormatPipe} from '../../pipes/date-format.pipe';

@Component({
    selector: 'app-item-details',
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss'],
    imports: [
        BreadcrumbsComponent,
        ProgressComponent,
        MatCard,
        MatCardTitle,
        MatCardContent,
        MatGridList,
        MatGridTile,
        AsyncPipe,
        BooleanPipe,
        DateFormatPipe,
        MatCardHeader
    ],
    standalone: true
})
export class ItemDetailsComponent implements OnInit, OnDestroy {

  @ViewChild(ProgressComponent, {static: true}) progress: ProgressComponent;

  itemId: string;
  item: Item = null;
  itemObservable: Observable<DocumentData>;
  itemSubscription: Subscription;
  breadcrumbs: BreadCrumb[];
  facility: Observable<DocumentData>;
  location: Observable<DocumentData>;
  private itemDocument: DocumentReference;
  private facilityDocument: DocumentReference;
  private locationDocument: DocumentReference;
  private facilitySubscription: Subscription;
  private locationSubscription: Subscription;

  constructor(
      private firestore: Firestore,
      private router: Router,
      private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.breadcrumbs = [
      {url: ['/'], title: 'Accounts'},
      {url: null, title: 'Facilities'},
      {url: null, title: ''},
    ];
    this.activeRoute.paramMap.subscribe(
        params => {
          this.itemId = params.get('itemId');
          if (this.itemId) {
            this.fetchItem();
          }
        }
    );
  }

    fetchItem() {
        this.progress.setVisible(true);
        const itemDocRef = doc(this.firestore, 'items', this.itemId);
        this.itemDocument = itemDocRef;
        this.itemObservable = docData(itemDocRef);
        this.itemSubscription = this.itemObservable.pipe(
            tap(data => {
                this.breadcrumbs[2].title = data.customerPartNumber;
                this.item = data as Item;
                this.progress.setVisible(false);
            })
        ).subscribe(result => {
            this.progress.setVisible(true);
            const facilityDocRef = doc(this.firestore, 'facilities', result.facility.id);
            this.facilityDocument = facilityDocRef;
            this.facility = docData(facilityDocRef);
            this.facilitySubscription = this.facility.pipe(
                tap(data => {
                    this.breadcrumbs[1] = { url: ['/facilities', data.accountId], title: 'Facilities' };
                    this.breadcrumbs[2] = {
                        url: ['/facilities', result.facility.id, 'locations'],
                        title: `Facility: ${data.name}`
                    };
                    this.progress.setVisible(false);
                })
            ).subscribe();

            if (result.location != null) {
                this.progress.setVisible(true);

                const locationDocRef = doc(
                    this.firestore,
                    'facilities',
                    result.facility.id,
                    'locations',
                    result.location.id
                );
                this.locationDocument = locationDocRef;
                this.location = docData(locationDocRef);
                this.locationSubscription = this.location.pipe(
                    tap(data => {
                        this.progress.setVisible(false);

                        this.breadcrumbs[3] = {
                            url: [
                                '/facilities',
                                result.facility.id,
                                'locations',
                                result.location.id,
                                'items'
                            ],
                            title: `Location: ${data.name}`
                        };
                        this.breadcrumbs[4] = { url: null, title: `Item Details: ${result.customerPartNumber}` };
                    })
                ).subscribe();
            } else {
                this.breadcrumbs[3] = { url: null, title: `Item Details: ${result.customerPartNumber}` };
            }
        });
    }


    ngOnDestroy(): void {
    if (this.itemSubscription != null) {
      this.itemSubscription.unsubscribe();
    }
    if (this.facilitySubscription != null) {
      this.facilitySubscription.unsubscribe();
    }
    if (this.locationSubscription != null) {
      this.locationSubscription.unsubscribe();
    }
  }
}
